import Header from './components/Header';
import MainVisual from './components/MainVisual';
import DiagnosisGrid from './components/DiagnosisGrid';
import Footer from './components/Footer';
import SeoHead from '@/components/base/SeoHead';

const SITE_URL = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '夜職タイプ診断',
    url: SITE_URL,
    description:
      'キャバ嬢・ホスト・夜職従事者のスタイルを16タイプで分析する無料診断サービス。24問・約3分で完了。',
    inLanguage: 'ja',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/quiz`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebApplication',
    name: '夜職タイプ診断',
    url: SITE_URL,
    applicationCategory: 'EntertainmentApplication',
    operatingSystem: 'Any',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'JPY',
      description: '24問の診断は完全無料',
    },
    description:
      'キャバ嬢・ホスト・夜職従事者のためのタイプ診断アプリ。24問・約3分・完全無料。',
    inLanguage: 'ja',
  },
];

export default function Home() {
  return (
    <div
      className="min-h-screen bg-white"
      style={{ fontFamily: "'M PLUS Rounded 1c', sans-serif" }}
    >
      <SeoHead
        title="夜職タイプ診断｜キャバ嬢・ホスト・夜職スタイルを16タイプで診断"
        description="夜職タイプ診断は、キャバ嬢・ホスト・夜職従事者のスタイルを16タイプで分析する無料診断サービス。24問・約3分で完了。あなたの夜職スタイルを今すぐ診断しよう。"
        keywords="夜職診断,キャバ嬢タイプ,ホストタイプ,夜職スタイル,16タイプ診断"
        canonical="/"
        jsonLd={homeJsonLd}
      />
      <Header onStartClick={() => {}} />
      <main>
        <MainVisual />
        <DiagnosisGrid />
      </main>
      <Footer />
    </div>
  );
}
